import React from 'react';
import { PageLayout } from '../../components';

/** Error Fallback. TODO: Can implement a nice screen here */
const ErrorFallBack: React.FC = () => (
  <PageLayout pageTitle="Something went wrong" loading={false} />
);

export default ErrorFallBack;
